import { useFormik } from "formik";
import { useState } from "react";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import Select from "react-select";
import * as Yup from "yup";
import { errorStyles } from "../../../../../components/selectStyles/customStyles";
import { getKycRules } from "../../../../../store/actions/compliance.action";
import {
  actionTypeOptions,
  complianceGroupOptions,
  documentTypeUpload,
  kycRuleTypeOptions,
  requiredDocumentsCondition,
  restrictionOptions,
} from "../../../../../utils/helpers/objectHelpers";
import { addKYCValidator } from "../../../../../utils/helpers/validationHelpers";
import { createKycRule } from "../../../../../utils/services/compliance.service";

const AddNewKYC = ({ languageStatus, dictionary, countries }) => {
  const dispatch = useDispatch();
  const menuPortalTarget = document.getElementById("root");
  const groupDropdown = complianceGroupOptions(
    languageStatus,
    dictionary,
    "KYC"
  );
  const kycRuleDropdown = kycRuleTypeOptions(languageStatus, dictionary);
  const restrictionDropdown = restrictionOptions(languageStatus, dictionary);
  const actionTypeDropdown = actionTypeOptions(languageStatus, dictionary);
  const requiredDocumentsChecks = requiredDocumentsCondition(dictionary);
  const [loading, setLoading] = useState(false);
  const [approveAccountOnExecution, setApproveAccountOnExecution] =
    useState(false);
  const [onSubmitClick, setOnSubmitClick] = useState(false);
  const [documentConditions, setDocumentConditions] = useState([
    ...requiredDocumentsChecks,
  ]);
  const [requiredDocsPayload, setPayload] = useState({});

  const onChange = (e) => {
    const temp = documentConditions.map((i, idx) => {
      if (i.name === e.target.name) {
        i = { ...i, value: e.target.checked };
      }
      return i;
    });
    setDocumentConditions([...temp]);
    setPayload({
      ...requiredDocsPayload,
      [e.target.name]: e.target.checked,
    });
  };

  const toggleCheckBox = () =>
    setApproveAccountOnExecution(!approveAccountOnExecution);

  const initialValidation = addKYCValidator();
  const initialValues = {
    country: "",
    ruleType: "",
    restriction: "",
    group: "",
    actionType: "",
    businessRuleNumber: "",
    eKYCProvider: "",
  };

  const formik = useFormik({
    initialValues,
    validationSchema: Yup.object(initialValidation),
    onSubmit: async () => {},
  });

  console.log(formik.errors);

  const addNewKYC = async () => {
    setOnSubmitClick(true);
    const payload = {
      knowYourCustomerRuleDTO: [
        {
          approveAccountOnExecution,
          businessRuleNumber: formik.values.businessRuleNumber,
          country: formik.values.country,
          ruleType: formik.values.ruleType.value,
          restriction: formik.values.restriction.value,
          thresholdLimitType: formik.values.group.value,
          actionType: formik.values.actionType.value,
          ...requiredDocsPayload,
        },
      ],
    };
    console.log(payload);
    if (Object.entries(formik.errors).length === 0) {
      setLoading(true);
      const { data: response } = await createKycRule(payload);
      if (response.status !== "SUCCESS") {
        toast.error("Something went wrong, kindly fill all required fields");
        setLoading(false);
      } else {
        setLoading(false);
        toast.success("kycRules created successfully");
        await dispatch(getKycRules());
      }
    }
  };

  const disableButton = formik.values.country === "";

  const allCountries = [
    {
      capital: "",
      common_name: "All",
      currencyCode: "",
      currencySymbol: null,
      delivery_methods: null,
      flag: null,
      iso2Code: "ALL",
      iso3Code: "ALL",
      label: "All",
      telephoneCode: "+995",
      value: "ALL",
    },
  ];

  const all = [...allCountries, ...countries];

  return (
    <div className="card-body">
      <form className="needs-validation">
        <div className="form-row">
          <div className="col-md-6 col-lg-6 mb-3">
            <label>
              {languageStatus
                ? dictionary["l_destination_country"]
                : "Receiving Country"}
              <span style={{ color: "red" }}> *</span>
            </label>
            <Select
              // options={countries}
              options={all}
              isClearable={false}
              isSearchable={true}
              maxMenuHeight={250}
              menuPlacement="bottom"
              menuPortalTarget={menuPortalTarget}
              name="country"
              isMulti
              value={formik.values.country}
              onChange={(option) => formik.setFieldValue("country", option)}
            />
          </div>
          <div className="col-md-6 col-lg-6 mb-3">
            <label>
              {languageStatus ? dictionary["l_group"] : "Group"}
              <span style={{ color: "red" }}> *</span>
            </label>
            <Select
              options={groupDropdown}
              isClearable={false}
              isSearchable={false}
              maxMenuHeight={250}
              menuPlacement="bottom"
              menuPortalTarget={menuPortalTarget}
              styles={
                formik.errors["group"] && onSubmitClick ? errorStyles : ""
              }
              name="group"
              value={formik.values.group}
              onChange={(option) => formik.setFieldValue("group", option)}
            />
          </div>
          <div className="col-md-6 col-lg-6 mb-3">
            <label>
              {languageStatus
                ? dictionary["para_rule_type"]
                : "Rule Type to apply"}
              <span style={{ color: "red" }}> *</span>
            </label>
            <Select
              options={kycRuleDropdown}
              isClearable={false}
              isSearchable={false}
              maxMenuHeight={250}
              menuPlacement="bottom"
              menuPortalTarget={menuPortalTarget}
              styles={
                formik.errors["ruleType"] && onSubmitClick ? errorStyles : ""
              }
              name="ruleType"
              value={formik.values.ruleType}
              onChange={(option) => formik.setFieldValue("ruleType", option)}
            />
          </div>
          <div className="col-md-6 col-lg-6 mb-3">
            <label>
              {languageStatus
                ? dictionary["RESTRICTION_TYP_-1672091348"]
                : "Restrictions"}
              <span style={{ color: "red" }}> *</span>
            </label>
            <Select
              options={restrictionDropdown}
              isClearable={false}
              isSearchable={false}
              maxMenuHeight={250}
              menuPlacement="bottom"
              menuPortalTarget={menuPortalTarget}
              styles={
                formik.errors["restriction"] && onSubmitClick ? errorStyles : ""
              }
              name="restriction"
              value={formik.values.restriction}
              onChange={(option) => formik.setFieldValue("restriction", option)}
            />
          </div>
          <div className="col-md-6 col-lg-6 mb-3">
            {/* formerly scopr of rule */}
            <label>
              {languageStatus
                ? dictionary["para_threshold_type"]
                : "Scope of Rule"}
              <span style={{ color: "red" }}> *</span>
            </label>
            <Select
              options={actionTypeDropdown}
              isClearable={false}
              isSearchable={false}
              maxMenuHeight={250}
              menuPlacement="bottom"
              menuPortalTarget={menuPortalTarget}
              styles={
                formik.errors["actionType"] && onSubmitClick ? errorStyles : ""
              }
              name="actionType"
              value={formik.values.actionType}
              onChange={(option) => formik.setFieldValue("actionType", option)}
            />
          </div>
          {/* EKYC PROVIDER */}
          {formik?.values?.actionType?.value ===
            "VERIFY_ACCOUNT_VIA_EKYC_FACE_PHOTO" ||
          formik?.values?.actionType?.value ===
            "VERIFY_ACCOUNT_VIA_EKYC_FACE_VIDEO" ||
          formik?.values?.actionType?.value ===
            "VERIFY_ACCOUNT_VIA_IDENTIFICATION_DOCUMENT" ? (
            <div className="col-md-6 col-lg-6 mb-3">
              <label>
                {languageStatus
                  ? dictionary["WO_EKYC_PROVIDE_-1567908493"]
                  : "eKYC Provider"}
                <span style={{ color: "red" }}> *</span>
              </label>
              <Select
                options={[]}
                isClearable={false}
                isSearchable={false}
                maxMenuHeight={250}
                menuPlacement="bottom"
                menuPortalTarget={menuPortalTarget}
                styles={
                  formik.errors["eKYCProvider"] && onSubmitClick
                    ? errorStyles
                    : ""
                }
                name="actionType"
                value={formik.values.eKYCProvider}
                onChange={(option) =>
                  formik.setFieldValue("eKYCProvider", option)
                }
              />
            </div>
          ) : (
            ""
          )}

          {/* DOCUMENT UPLOAD TYPE */}
          {formik?.values?.actionType?.value ===
            "VERIFY_ACCOUNT_VIA_IDENTIFICATION_DOCUMENT" && (
            <div className="col-md-6 col-lg-6 mb-3">
              <label>
                {languageStatus
                  ? dictionary["WO_DOCUMENTS_UPLOAD_TYP_-1320457191"]
                  : "Documents Upload Type"}
              </label>
              <Select
                options={documentTypeUpload()}
                isClearable={false}
                isSearchable={false}
                maxMenuHeight={250}
                menuPlacement="bottom"
                menuPortalTarget={menuPortalTarget}
                styles={
                  formik.errors["docTypeUpload"] && onSubmitClick
                    ? errorStyles
                    : ""
                }
                name="docTypeUpload"
                value={formik.values.docTypeUpload}
                onChange={(option) =>
                  formik.setFieldValue("docTypeUpload", option)
                }
              />
            </div>
          )}

          {/* CHECKBOXES FOR UPLOADS */}
          {formik?.values?.docTypeUpload?.value ===
            "Multiple Document Upload" && (
            <div className="col-lg-12 col-md-12 mb-4">
              <h6 className="fw-bold mx-auto text-center pt-3 pb-3">
                {dictionary
                  ? dictionary["para_requirements"]
                  : `
                Required Documents (Customer will be asked to upload the
                selected document(s) while performing a transactions)`}
              </h6>
              <div className="form form-row">
                {documentConditions.map((i) => {
                  return (
                    <>
                      <div className="col-lg-6 col-md-6 mb-3" key={i.id}>
                        <div className="form-row m-0">
                          <label className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              defaultChecked={false}
                              onChange={onChange}
                              name={i.name}
                            />
                            <span className="custom-control-label pointer fs-12">
                              <span>{i.label}</span>
                            </span>
                          </label>
                        </div>
                      </div>
                    </>
                  );
                })}
              </div>
            </div>
          )}
          <div className="col-md-6 col-lg-6 mb-3">
            <label>
              {languageStatus
                ? dictionary["WO_RULE_SCOR_-1334001714"] + " (%)"
                : "Rule Score"}
              <span style={{ color: "red" }}> *</span>
            </label>
            <input
              type="number"
              min="1"
              max="100"
              maxLength={100}
              name="businessRuleNumber"
              value={formik.values.businessRuleNumber}
              className={`form-control`}
              onChange={formik.handleChange}
              required
            />
          </div>
          <div className="col-md-12 mb-3 text-end">
            <div className="form-row m-0">
              <label className="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  defaultChecked={false}
                  onChange={toggleCheckBox}
                />
                <span className="custom-control-label pointer fs-12">
                  <span>
                    {" "}
                    {languageStatus
                      ? dictionary["WO_AUTOMATICALLY_APPROV_710831922"]
                      : "Approve"}
                  </span>
                </span>
              </label>
            </div>
            <button
              disabled={disableButton}
              onClick={addNewKYC}
              className="btn btn-primary margin-label width-25"
              type="button"
            >
              Add
              {loading && (
                <>
                  &nbsp;
                  <i className="fa fa-spinner fa-spin" />
                </>
              )}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default AddNewKYC;
